import { useEffect, useState, useCallback, useRef } from 'react';

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export const useRecaptcha = () => {
  const [isReady, setIsReady] = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    // Check if grecaptcha is already loaded
    if (window.grecaptcha && window.grecaptcha.ready) {
      window.grecaptcha.ready(() => {
        setIsReady(true);
      });
      return;
    }
    
    // Poll for grecaptcha to be loaded
    intervalRef.current = setInterval(() => {
      if (window.grecaptcha && window.grecaptcha.ready) {
        window.grecaptcha.ready(() => {
          setIsReady(true);
        });
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
      }
    }, 100);

    // Cleanup
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  const executeRecaptcha = useCallback(async (action) => {
    if (!isReady || !window.grecaptcha) {
      throw new Error('reCAPTCHA not ready');
    }

    try {
      const token = await window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action });
      return token;
    } catch (error) {
      // Error logged for debugging, replace with logging service in production
      throw error;
    }
  }, [isReady]);

  return {
    isReady,
    executeRecaptcha: isReady ? executeRecaptcha : null
  };
};
